/* Collection behaviour: auto-apply filters, sort, mobile filter toggle.
   Without JS the form still submits via the <noscript> button. */
(function () {
  'use strict';

  var form = document.getElementById('tih-filter-form');
  if (form) {
    // checkboxes and price fields apply on change; debounce typing in price
    var t = null;
    form.addEventListener('change', function (e) {
      if (e.target.type === 'checkbox') form.submit();
    });
    form.addEventListener('input', function (e) {
      if (e.target.type === 'number') {
        clearTimeout(t);
        t = setTimeout(function () { form.submit(); }, 600);
      }
    });
  }

  var sort = document.getElementById('tih-sort');
  if (sort && form) {
    sort.addEventListener('change', function () { form.submit(); });
  }

  var toggle = document.querySelector('.tih-collection__filtertoggle');
  var panel = document.getElementById('tih-filters');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
